module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "profile-page"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.fetchingProfileData) ? _c('div', {
    staticClass: "loader-container"
  }, [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.fetchingProfileData) ? [_c('section', {
    staticClass: "profile-content"
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "validation error"
  }, _vm._l((_vm.errors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.errors.length === 0) ? [_c('div', {
    staticClass: "details"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.avatarImage
    }
  }), _vm._v(" "), (_vm.deleteFriendMode) ? _c('div', {
    staticClass: "delete-friend-form"
  }, [_c('h1', [_vm._v("Really Delete?")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeFriend($event)
      }
    }
  }, [_vm._v("Yes!")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteFriendMode = false
      }
    }
  }, [_vm._v("Cancel")])]) : _vm._e(), _vm._v(" "), (_vm.editProfileMode) ? _c('div', {
    staticClass: "edit-stats"
  }, [_c('div', {
    staticClass: "stats-properties"
  }, [_c('label', [_c('span', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.realName),
      expression: "editDetails.realName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editDetails.realName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDetails, "realName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.location),
      expression: "editDetails.location"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editDetails.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDetails, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Share Age")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.showAge),
      expression: "editDetails.showAge"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editDetails.showAge) ? _vm._i(_vm.editDetails.showAge, null) > -1 : (_vm.editDetails.showAge)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editDetails.showAge,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editDetails, "showAge", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editDetails, "showAge", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editDetails, "showAge", $$c)
        }
      }
    }
  })]), _vm._v(" "), (_vm.editDetails.showAge) ? _c('label', [_c('span', [_vm._v("Birthday")]), _vm._v(" "), _c('span', {
    staticClass: "select-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.birthMonth),
      expression: "editDetails.birthMonth"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "birthMonth", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Feb")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Mar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Apr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("May")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("June")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("July")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Aug")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Sep")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Oct")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Nov")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Dec")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.birthDay),
      expression: "editDetails.birthDay"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "birthDay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((31), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.birthYear),
      expression: "editDetails.birthYear"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "birthYear", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.yearRange(1900)), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('label', [_c('span', [_vm._v("Gender")]), _vm._v(" "), _c('div', {
    staticClass: "sub-label"
  }, [_c('label', [_c('span', [_vm._v("Male")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.gender),
      expression: "editDetails.gender"
    }],
    attrs: {
      "type": "radio",
      "value": "Male"
    },
    domProps: {
      "checked": _vm._q(_vm.editDetails.gender, "Male")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editDetails, "gender", "Male")
      }
    }
  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Female")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.gender),
      expression: "editDetails.gender"
    }],
    attrs: {
      "type": "radio",
      "value": "Female"
    },
    domProps: {
      "checked": _vm._q(_vm.editDetails.gender, "Female")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.editDetails, "gender", "Female")
      }
    }
  })])])]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Share Height")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.showHeight),
      expression: "editDetails.showHeight"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editDetails.showHeight) ? _vm._i(_vm.editDetails.showHeight, null) > -1 : (_vm.editDetails.showHeight)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editDetails.showHeight,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editDetails, "showHeight", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editDetails, "showHeight", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editDetails, "showHeight", $$c)
        }
      }
    }
  })]), _vm._v(" "), (_vm.editDetails.showHeight) ? _c('label', [_c('span', [_vm._v("Height")]), _vm._v(" "), (!_vm.useMetric) ? _c('span', {
    staticClass: "select-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.heightFeet),
      expression: "editDetails.heightFeet"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "heightFeet", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((6), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + "'")])
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.heightInches),
      expression: "editDetails.heightInches"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.editDetails, "heightInches", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((11), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + "\"")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.useMetric) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editDetails.metricHeight),
      expression: "editDetails.metricHeight"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Height in cm"
    },
    domProps: {
      "value": (_vm.editDetails.metricHeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editDetails, "metricHeight", $event.target.value)
      }
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveProfileData($event)
      }
    }
  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (!_vm.deleteFriendMode && !_vm.editProfileMode) ? _c('div', {
    staticClass: "stats"
  }, [_c('div', {
    staticClass: "stats-properties"
  }, [(_vm.profileData.alias) ? _c('span', {
    staticClass: "alias"
  }, [_vm._v(_vm._s(_vm.profileData.alias))]) : _vm._e(), _vm._v(" "), (_vm.profileData.realName) ? _c('span', [_vm._v(_vm._s(_vm.profileData.realName))]) : _vm._e(), _vm._v(" "), (_vm.profileData.location) ? _c('span', [_vm._v(_vm._s(_vm.profileData.location))]) : _vm._e(), _vm._v(" "), (_vm.compoundStats) ? _c('span', [_vm._v(_vm._s(_vm.compoundStats))]) : _vm._e(), _vm._v(" "), (_vm.profileData.registrationDate) ? _c('span', [_vm._v("Member since " + _vm._s(_vm._f("formatDateWithoutTime")(_vm.profileData.registrationDate)))]) : _vm._e()]), _vm._v(" "), (_vm.retrievedFriendStatus) ? [(_vm.buttonToUse === 'addFriend') ? _c('button', {
    attrs: {
      "disabled": _vm.isUpdatingFriendStatus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addFriend($event)
      }
    }
  }, [_vm._v("Add Friend\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'removeFriend') ? _c('button', {
    attrs: {
      "disabled": _vm.isUpdatingFriendStatus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteFriendMode = true
      }
    }
  }, [_vm._v("Remove Friend\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'friendRequestSent') ? _c('button', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Friend Request Pending\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'acceptFriend') ? _c('button', {
    attrs: {
      "disabled": _vm.isUpdatingFriendStatus
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.acceptFriendRequest($event)
      }
    }
  }, [_vm._v("Accept Friend Request\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.buttonToUse === 'editProfile') ? _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editProfileMode = true
      }
    }
  }, [_vm._v("Edit Profile\n                            ")]) : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ad-container"
  }, [_c('ad-container', {
    attrs: {
      "ad-slot": "6967449791"
    }
  })], 1)]), _vm._v(" "), _c('photo-manager', {
    attrs: {
      "photos": _vm.profileData.photos,
      "is-own-profile": _vm.isOwnProfile,
      "memberId": _vm.profileData.id
    }
  }), _vm._v(" "), (_vm.profileData.bio || _vm.isOwnProfile) ? _c('h1', [_vm._v("Bio")]) : _vm._e(), _vm._v(" "), (!_vm.editBioMode && _vm.profileData.bio) ? _c('pre', {
    staticClass: "bio"
  }, [_vm._v(_vm._s(_vm.profileData.bio))]) : _vm._e(), _vm._v(" "), (_vm.editBioMode) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editBioContent),
      expression: "editBioContent"
    }],
    staticClass: "edit-bio-content",
    attrs: {
      "maxlength": "600"
    },
    domProps: {
      "value": (_vm.editBioContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editBioContent = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOwnProfile && !_vm.editBioMode) ? _c('button', {
    staticClass: "edit-bio-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.editBioMode = true
      }
    }
  }, [_vm._v("Edit Bio")]) : _vm._e(), _vm._v(" "), (_vm.isOwnProfile && _vm.editBioMode) ? _c('button', {
    staticClass: "edit-bio-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveBio($event)
      }
    }
  }, [_vm._v("Save Bio")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "large-ad"
  }, [_c('ad-container', {
    attrs: {
      "ad-slot": "2462240339"
    }
  })], 1), _vm._v(" "), _c('browse-more-profiles', {
    attrs: {
      "current-member-id": _vm.profileData.id
    }
  })] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), _c('footer', [_vm._v("Mixsii is a Free Video Chat Room Service, with a list of chat rooms. HD Video Chat with friends, family, and strangers completely free from your web browser. No download required to make it work! Group calls and Video Conferencing is available. Browse the list of video chat rooms for teen, adults, and enthusiasts. Mixsii is cross-browser, and even works on Android and iOS Apple Devices.")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/mixsii-logo.svg"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Free Video Chat Rooms")]), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "href": "/Chat"
    }
  }, [_vm._v("Chat Now!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51402acc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ProfilePage/ProfilePage.vue
// module id = 400
// module chunks = 1